import React from "react";
import * as styles from "./SectionTitle.module.scss"

const SectionTitleColored = ({text}) => {
    return(<h2 className={styles.container} style={{color : "#F1C576"}}>{text}</h2>)
}
export default SectionTitleColored;